import type { ClientAndInvestmentAccountDto } from '../dto';
import type { ClientAndInvestmentAccount } from '../models';

export const mapClientAndInvestmentAccountDtoToModel = (
  dto: ClientAndInvestmentAccountDto,
): ClientAndInvestmentAccount => ({ ...dto });

export const mapClientAndInvestmentAccountListDtoToModel = (
  dto: ClientAndInvestmentAccountDto[],
): ClientAndInvestmentAccount[] =>
  dto.map(mapClientAndInvestmentAccountDtoToModel);
